import { pluralize } from '@/portainer/helpers/strings';

import { TextTip } from '@@/Tip/TextTip';

export interface Props {
  size: number;
}

export function AttachmentsDatatableDescription({ size }: Props) {
  return (
    <TextTip color="blue" data-cy="attachments-group-size">
      Size: {size} {pluralize(size, 'environment')}
    </TextTip>
  );
}
